module.exports = __webpack_public_path__ + "static/media/sy_dummies.53dab30f.jpeg";